import request from './request';

export const baseApi = {
  ImageUploader: (formData) => request({
    url: '/api/upload',
    method: 'post',
    data: formData
  }),
  GetCategory: () => request({ url: '/api/catalogs', method: 'get' }),
  GetCreator: (keyword) => request({ url: `/api/creators?keyword=${keyword}` }),
  // 获取产品列表
  getProducts: (params) => request({ url: '/api/erp/products/list', method: 'get', params }),
  getProductByName: (productString) => request({ url: '/api/erp/products/getproductbyname', method: 'post', data: { productString } }),
}

export const unitApi = {
  getUnits: () => request({ url: '/api/units', method: 'get' }),
  createUnit: (data) => request({ url: '/api/units', method: 'post', data }),
}

// 分类管理接口
export const categoryApi = {
  // 获取分类列表（分页）
  getCategoryList: (data) => request({ url: '/api/categories/grid', method: 'post', data }),
  // 获取所有分类（不分页，用于选择）
  getAllCategories: () => request({ url: '/api/categories', method: 'get' }),
  // 获取分类详情
  getCategoryDetail: (id) => request({ url: `/api/categories/${id}`, method: 'get' }),
  // 创建分类
  createCategory: (data) => request({ url: '/api/categories', method: 'post', data }),
  // 更新分类
  updateCategory: (id, data) => request({ url: `/api/categories/${id}`, method: 'put', data }),
  // 删除分类
  deleteCategory: (id) => request({ url: `/api/categories/${id}`, method: 'delete' }),
  // 切换菜单显示状态
  switchInMenu: (id) => request({ url: `/api/categories/switch/${id}`, method: 'put' }),
};

// 自动完成相关接口
export const autocompleteApi = {
  // 获取客户列表（用于自动完成）
  getCustomers: (keyword) => request({
    url: '/api/erp/customers/grid',
    method: 'post',
    data: {
      current: 1,
      pageSize: 10,
      search: {
        CustomerName: keyword
      }
    }
  }),

  // 获取供应商列表（用于自动完成）
  getSuppliers: (keyword) => request({
    url: '/api/erp/suppliers/grid',
    method: 'post',
    data: {
      current: 1,
      pageSize: 10,
      search: {
        keyword: keyword
      }
    }
  }),

  getSalemans: (keyword) => request({
    url: '/api/erp/salemans/grid', method: 'post', data: {
      current: 1,
      pageSize: 10,
      search: {
        keyword: keyword
      }
    }
  }),
  // 获取制单人列表（用于自动完成）
  getCreators: (keyword) => request({
    url: '/api/creators',
    method: 'get',
    params: {
      keyword: keyword,
      take: 10
    }
  }),

  // 获取商品列表（用于自动完成）
  getProducts: (keyword) => request({
    url: '/api/erp/products/grid',
    method: 'post',
    data: {
      current: 1,
      pageSize: 10,
      search: {
        Name: keyword
      }
    }
  }),
  getBanks: (keyword) => request({
    url: '/api/erp/bankaccounts/grid',
    method: 'post',
    data: {
      pagination: {
        current: 1,
        pageSize: 10
      },
      search: {
        accountName: keyword,
        accountCode: ""
      }
    }
  })

}
export const messagesApi = {
  getMessages: (data) => request({ url: '/api/messages/grid', method: 'post', data }),
  markMessageAsRead: (data) => request({ url: `/api/messages/markread`, method: 'post', data }),
  markAllMessagesAsRead: () => request({ url: '/api/messages/markallread', method: 'post' }),
  deleteMessage: (id) => request({ url: `/api/messages/${id}`, method: 'delete' }),
}

// 消息配置相关接口
export const messageConfigApi = {
  // 获取消息流程列表
  getProcessList: (data) => request({ url: '/api/message-config/process/grid', method: 'post', data }),
  // 获取消息流程详情
  getProcessDetail: (id) => request({ url: `/api/message-config/process/${id}`, method: 'get' }),
  // 创建消息流程
  createProcess: (data) => request({ url: '/api/message-config/process', method: 'post', data }),
  // 更新消息流程
  updateProcess: (id, data) => request({ url: `/api/message-config/process/${id}`, method: 'put', data }),
  // 删除消息流程
  deleteProcess: (id) => request({ url: `/api/message-config/process/${id}`, method: 'delete' }),
  // 获取用户列表
  getUsers: (params) => request({ url: '/api/message-config/users', method: 'get', params }),
  // 获取订单类型列表
  getOrderTypes: () => request({ url: '/api/message-config/order-types', method: 'get' }),
  // 获取流程状态列表
  getProcessStatuses: (orderType) => {
    const params = orderType !== undefined ? { orderType } : {};
    return request({ url: '/api/message-config/process-statuses', method: 'get', params });
  }
}
export const deliveryApi = {
  getDeliveryList: (data) => request({ url: '/api/erp/delivery/grid', method: 'post', data }),
  getDeliveryDetail: (id) => request({ url: `/api/erp/delivery/${id}`, method: 'get' }),
  getDeliveryByOrderId: (orderId) => request({ url: `/api/erp/delivery/by-order/${orderId}`, method: 'get' }),
  createDelivery: (data) => request({ url: '/api/erp/delivery/create', method: 'post', data }),
  updateDelivery: (id, data) => request({ url: `/api/erp/delivery/${id}`, method: 'put', data }),
  createOrUpdateByOrder: (data) => request({ url: '/api/erp/delivery/create-or-update-by-order', method: 'post', data }),
  updateDeliveryInfo: (id, data) => request({ url: `/api/erp/delivery/${id}/update-delivery-info`, method: 'put', data }),
  deleteDelivery: (id) => request({ url: `/api/erp/delivery/${id}`, method: 'delete' }),
}
// 用户相关接口
export const userApi = {
  // 用户名/邮箱/手机号登录
  login: (data) => request({ url: '/api/account/login', method: 'post', data }),
  // 兼容旧调用名称
  loginByPhone: (data) => request({ url: '/api/account/login', method: 'post', data }),
  // 检查用户是否为商户
  checkMerchant: () => request({ url: '/api/account/checkmerchant', method: 'post' }),
  // 用户注册
  register: (data) => request({ url: '/user/register', method: 'post', data }),
  // 获取用户信息
  getUserInfo: () => request({ url: '/user/info', method: 'get' }),

  // 用户管理相关接口
  // 快速搜索用户
  quickSearch: (nameOrPhone, take = 20) => request({ url: '/api/users/quick-search', method: 'get', params: { nameOrPhone, take } }),
  // 获取用户列表（分页）
  getUserList: (data) => request({ url: '/api/users/grid', method: 'post', data }),
  // 根据ID获取用户详情
  getUserById: (id) => request({ url: `/api/users/${id}`, method: 'get' }),
  // 创建用户
  createUser: (data) => request({ url: '/api/users', method: 'post', data }),
  // 更新用户
  updateUser: (id, data) => request({ url: `/api/users/${id}`, method: 'put', data }),
  // 删除用户
  deleteUser: (id) => request({ url: `/api/users/${id}`, method: 'delete' }),
  // 获取用户地址列表
  getUserAddresses: (userId) => request({ url: `/api/users/${userId}/addresses`, method: 'get' }),
  // 修改密码
  changePassword: (data) => request({ url: '/api/users/change-password', method: 'post', data }),
  // 修改头像
  changeAvatar: (data) => request({ url: '/api/users/change-avatar', method: 'post', data }),
  // 修改审批授权码
  changeAuthCode: (data) => request({ url: '/api/account/change-auth-code', method: 'post', data }),
  // 获取审批授权码状态
  getAuthCodeStatus: () => request({ url: '/api/account/auth-code-status', method: 'get' })
};

// 角色权限相关接口
export const platformCompanyApi = {
  getCompanyList: (data) => request({ url: '/api/platform/companies/grid', method: 'post', data }),
  getCompanyById: (id) => request({ url: `/api/platform/companies/${id}`, method: 'get' }),
  createCompany: (data) => request({ url: '/api/platform/companies', method: 'post', data }),
  renewCompany: (id, data) => request({ url: `/api/platform/companies/${id}/renew`, method: 'post', data }),
  getRenewals: (id) => request({ url: `/api/platform/companies/${id}/renewals`, method: 'get' }),
  updateStatus: (id, data) => request({ url: `/api/platform/companies/${id}/status`, method: 'post', data }),
  getCurrentSubscription: () => request({ url: '/api/company/subscription', method: 'get' })
};

export const roleApi = {
  // 获取所有角色列表
  getRoles: () => request({ url: '/api/roles', method: 'get' }),
  // 根据ID获取角色详情
  getRoleById: (id) => request({ url: `/api/roles/${id}`, method: 'get' }),
  // 批量设置角色权限
  setRoleClaims: (id, data) => request({ url: `/api/roles/${id}/claims`, method: 'put', data }),
  // 获取系统预定义权限列表
  getPermissions: () => request({ url: '/api/roles/permissions', method: 'get' }),

  // 审核权限相关接口
  // 获取待审核权限申请列表
  getAuditRequests: () => request({ url: '/api/roles/audit-requests', method: 'get' }),
  // 批准权限申请
  approveAuditRequest: (id) => request({ url: `/api/roles/audit-requests/${id}/approve`, method: 'post' }),
  // 拒绝权限申请
  rejectAuditRequest: (id) => request({ url: `/api/roles/audit-requests/${id}/reject`, method: 'post' }),
  // 申请审核权限
  requestAuditPermission: (data) => request({ url: '/api/roles/audit-requests', method: 'post', data }),
  // 检查用户是否有指定审核权限
  checkAuditPermission: (module) => request({ url: `/api/roles/check-audit-permission/${module}`, method: 'get' }),
  // 获取角色权限声明
  getRoleClaims: (roleId) => request({ url: `/api/roles/${roleId}/claims`, method: 'get' }),
  // 添加角色权限声明
  addRoleClaim: (roleId, claim) => request({ url: `/api/roles/${roleId}/claims`, method: 'post', data: claim }),
  // 移除角色权限声明
  removeRoleClaim: (roleId, claim) => request({ url: `/api/roles/${roleId}/claims`, method: 'delete', data: claim })
};

// 权限配置相关接口
export const permissionConfigApi = {
  // 获取权限系统配置
  getConfig: () => request({ url: '/api/permission-config', method: 'get' }),
  // 更新权限系统配置
  updateConfig: (data) => request({ url: '/api/permission-config', method: 'put', data }),
  // 获取权限系统状态
  getStatus: () => request({ url: '/api/permission-config/status', method: 'get' }),
  // 重置权限系统配置
  resetConfig: () => request({ url: '/api/permission-config/reset', method: 'post' })
};

// 客户相关接口
export const customersApi = {
  getCustomers: (data) => request({ url: '/api/erp/customers/grid', method: 'post', data }),
  //getCustomerList: (params) => request({url: '/api/erp/customers/list',method: 'get',params}),
  getCustomerDetail: (id) => request({ url: `/api/erp/customers/${id}`, method: 'get' }),
  createCustomer: (data) => request({ url: '/api/erp/customers/create', method: 'post', data }),
  updateCustomer: (id, data) => request({ url: `/api/erp/customers/${id}`, method: 'put', data }),
  deleteCustomer: (id) => request({ url: `/api/erp/customers/${id}`, method: 'delete' }),
  updateCustomerStatus: (data) => request({ url: '/api/erp/customers/UpdateCustomerStatus', method: 'post', data }),
  // 客户分类相关接口
  getCategories: () => request({ 
    url: '/api/erp/customers/customerscategory', 
    method: 'post',
    timeout: 10000,
    retry: 2
  }),
  getCategoryTree: () => request({ 
    url: '/api/erp/customers/category/tree', 
    method: 'get',
    timeout: 10000,
    retry: 2
  }),
  getCategoryList: () => request({ 
    url: '/api/erp/customers/category/list', 
    method: 'get',
    timeout: 10000,
    retry: 2
  }),
  createCategory: (data) => {
    if (!data || !data.name) {
      return Promise.reject(new Error('分类名称不能为空'));
    }
    return request({ 
      url: '/api/erp/customers/category/create', 
      method: 'post', 
      data,
      timeout: 10000
    });
  },
  updateCategory: (id, data) => {
    if (!id || !data || !data.name) {
      return Promise.reject(new Error('参数不完整'));
    }
    return request({ 
      url: `/api/erp/customers/category/${id}`, 
      method: 'put', 
      data,
      timeout: 10000
    });
  },
  deleteCategory: (id) => {
    if (!id) {
      return Promise.reject(new Error('分类ID不能为空'));
    }
    return request({ 
      url: `/api/erp/customers/category/${id}`, 
      method: 'delete',
      timeout: 10000
    });
  },

  // 一客一价相关接口
  getCustomerProductPrices: (data) => request({ url: '/api/erp/customers/pricing/grid', method: 'post', data }),
  getCustomerProductPrice: (id) => request({ url: `/api/erp/customers/pricing/${id}`, method: 'get' }),
  createCustomerProductPrice: (data) => request({ url: '/api/erp/customers/pricing/create', method: 'post', data }),
  updateCustomerProductPrice: (id, data) => request({ url: `/api/erp/customers/pricing/${id}`, method: 'put', data }),
  deleteCustomerProductPrice: (id) => request({ url: `/api/erp/customers/pricing/${id}`, method: 'delete' }),
  batchUpdateCustomerProductPriceStatus: (ids, isActive) => request({ url: `/api/erp/customers/pricing/batch-toggle?isActive=${isActive}`, method: 'post', data: ids }),
  getCustomerProductPriceHistory: (data) => request({ url: '/api/erp/customers/pricing/history/grid', method: 'post', data }),
  calculateCustomerProductPrice: (data) => request({ url: '/api/erp/customers/pricing/calculate', method: 'post', data }),
  
  // Excel导出接口
  exportToExcel: (params) => request({ url: '/api/erp/customers/export', method: 'post', data: params, responseType: 'blob' }),
  
  // 经营范围相关接口
  getBusinessScopes: () => request({ url: '/api/erp/customers/business-scope-categories', method: 'get' }),
  createBusinessScope: (data) => request({ url: '/api/erp/customers/business-scope-categories', method: 'post', data }),
  getCustomerBusinessScope: (customerId) => request({ url: `/api/erp/customers/${customerId}/business-scopes`, method: 'get' }),
  updateCustomerBusinessScope: (customerId, data) => request({ url: `/api/erp/customers/${customerId}/business-scopes`, method: 'put', data })
};
export const salesmanApi = {
  // 获取业务员列表（分页）
  getSalemans: (data) => request({ url: '/api/erp/salemans/grid', method: 'post', data }),
  // 获取所有业务员列表（不分页，用于下拉选择）
  getAllSalemans: () => request({ url: '/api/erp/salemans', method: 'get' }),
  // 根据ID获取业务员详情
  getSalesmanById: (id) => request({ url: `/api/erp/salemans/${id}`, method: 'get' }),
  // 创建业务员
  createSalesman: (data) => request({ url: '/api/erp/salemans/create', method: 'post', data }),
  // 更新业务员
  updateSalesman: (id, data) => request({ url: `/api/erp/salemans/${id}`, method: 'put', data }),
  // 删除业务员
  deleteSalesman: (id) => request({ url: `/api/erp/salemans/${id}`, method: 'delete' }),
};

export const warehouseApi = {
  // 获取仓库列表（分页）
  getWarehouses: (data) => request({ url: '/api/erp/warehouses/grid', method: 'post', data }),
  // 获取仓库详情
  getWarehouseDetail: (id) => request({ url: `/api/erp/warehouses/${id}`, method: 'get' }),
  // 创建仓库
  createWarehouse: (data) => request({ url: '/api/erp/warehouses', method: 'post', data }),
  // 更新仓库
  updateWarehouse: (id, data) => request({ url: `/api/erp/warehouses/${id}`, method: 'put', data }),
  // 删除仓库
  deleteWarehouse: (id) => request({ url: `/api/erp/warehouses/${id}`, method: 'delete' }),
  // 批量删除仓库
  batchDeleteWarehouses: (ids) => request({ url: '/api/erp/warehouses/batch-delete', method: 'post', data: ids }),
  // 更新仓库状态
  updateWarehouseStatus: (id, isActive) => request({ url: `/api/erp/warehouses/${id}/status`, method: 'put', data: isActive }),
  // 获取所有启用的仓库（用于下拉选择）
  getActiveWarehouses: () => request({ url: '/api/erp/warehouses/active', method: 'get' }),
}
export const inventoryApi = {
  // 获取库存列表
  getInventoryList: (data) => request({ url: '/api/erp/inventory/stocks/grid', method: 'post', data }),
  getInventoryDetail: (id) => request({ url: `/api/erp/inventory/${id}`, method: 'get' }),
  // 获取库存统计
  getInventoryStatistics: () => request({ url: '/api/erp/inventory/statistics', method: 'get' }),
  // 获取商品信息
  getProductInfo: (productId) => request({ url: `/api/erp/inventory/product/${productId}`, method: 'get' }),
  // 获取库存历史记录
  getInventoryHistory: (data) => request({ url: '/api/erp/inventory/history/grid', method: 'post', data }),
  // 导出库存列表
  exportInventoryList: (data) => request({ url: '/api/erp/inventory/stocks/export', method: 'post', data, responseType: 'blob' }),

  // 库存盘点相关接口
  getInventoryCheckList: (data) => request({ url: '/api/erp/inventory/inventory-check/list', method: 'post', data }),
  getInventoryCheckDetail: (id) => request({ url: `/api/erp/inventory/inventory-check/${id}`, method: 'get' }),
  saveInventoryCheck: (data) => request({ url: '/api/erp/inventory/inventory-check', method: 'post', data }),
  updateInventoryCheck: (data) => request({ url: '/api/erp/inventory/inventory-check/update', method: 'post', data }),
  deleteInventoryCheck: (id) => request({ url: `/api/erp/inventory/inventory-check/${id}`, method: 'delete' }),
  auditInventoryCheck: (id, data = {}) => request({ url: `/api/erp/inventory/inventory-check/${id}/audit`, method: 'post', data }),
  unauditInventoryCheck: (id, data = {}) => request({ url: `/api/erp/inventory/inventory-check/${id}/unaudit`, method: 'post', data }),
  // 导出库存盘点列表
  exportInventoryCheckList: (data) => request({ url: '/api/erp/inventory/inventory-check/export', method: 'post', data, responseType: 'blob' }),
  // 导出库存盘点明细
  exportInventoryCheckDetails: (data) => request({ url: '/api/erp/inventory/inventory-check/export-details', method: 'post', data, responseType: 'blob' }),

  // 组装拆装相关接口
  getAssemblyList: (data) => request({ url: '/api/erp/inventory/assembly/list', method: 'post', data }),
  getAssemblyDetail: (id) => request({ url: `/api/erp/inventory/assembly/${id}`, method: 'get' }),
  saveAssembly: (data) => request({ url: '/api/erp/inventory/assembly', method: 'post', data }),
  updateAssembly: (id, data) => request({ url: `/api/erp/inventory/assembly/${id}`, method: 'put', data }),
  deleteAssembly: (id) => request({ url: `/api/erp/inventory/assembly/${id}`, method: 'delete' }),
  auditAssembly: (id, data) => request({ url: `/api/erp/inventory/assembly/${id}/audit`, method: 'post', data }),

  // 其他出入库相关接口
  getOtherInOutboundList: (data) => request({ url: '/api/erp/inventory/other-inoutbound/list', method: 'post', data }),
  getOtherInOutboundDetail: (id) => request({ url: `/api/erp/inventory/other-inoutbound/${id}`, method: 'get' }),
  saveOtherInOutbound: (data) => request({ url: '/api/erp/inventory/other-inoutbound', method: 'post', data }),
  updateOtherInOutbound: (id, data) => request({ url: `/api/erp/inventory/other-inoutbound/${id}`, method: 'put', data }),
  deleteOtherInOutbound: (id) => request({ url: `/api/erp/inventory/other-inoutbound/${id}`, method: 'delete' }),
  auditOtherInOutbound: (id, data) => request({ url: `/api/erp/inventory/other-inoutbound/${id}/audit`, method: 'post', data }),

  // 统一的其他出入库接口
  getOtherInboundList: (data) => {
    const params = {
      ...data,
      search: { ...data.search, orderType: 1 }
    };
    return request({ url: '/api/erp/inventory/other-inoutbound/list', method: 'post', data: params });
  },
  getOtherOutboundList: (data) => {
    const params = {
      ...data,
      search: { ...data.search, orderType: 2 }
    };
    return request({ url: '/api/erp/inventory/other-inoutbound/list', method: 'post', data: params });
  },
  deleteOtherInbound: (id) => request({ url: `/api/erp/inventory/other-inoutbound/${id}`, method: 'delete' }),
  deleteOtherOutbound: (id) => request({ url: `/api/erp/inventory/other-inoutbound/${id}`, method: 'delete' }),
  auditOtherInbound: (id, data = {}) => request({ url: `/api/erp/inventory/other-inoutbound/${id}/audit`, method: 'post', data }),
  auditOtherOutbound: (id, data = {}) => request({ url: `/api/erp/inventory/other-inoutbound/${id}/audit`, method: 'post', data })
}

export const salesApi = {
  // 销售订单相关接口
  createOrder: (data) => request({ url: '/api/erp/sales/orders', method: 'post', data }),
  getSalesList: (data) => request({ url: '/api/erp/sales/grid', method: 'post', data }),
  AuditOrder: (data) => request({ url: '/api/erp/sales/orders/audit', method: 'post', data }),
  UnAuditOrder: (data) => request({ url: '/api/erp/sales/orders/unaudit', method: 'post', data }),
  AuditOrderBySalesman: (id) => request({ url: '/api/erp/sales/orders/salesman-audit', method: 'post', data: id }),
  UnAuditOrderBySalesman: (id) => request({ url: '/api/erp/sales/orders/salesman-unaudit', method: 'post', data: id }),
  DeleteOrder: (id) => request({ url: `/api/erp/sales/orders/${id}`, method: 'delete' }),
  getSalesOrderById: (id) => request({ url: `/api/erp/sales/${id}`, method: 'get' }),
  getSalesDetail: (id) => request({ url: `/api/erp/sales/${id}`, method: 'get' }),
  getListByIds: (ids) => request({
    url: '/api/erp/sales/list-by-ids',
    method: 'post',
    data: ids
  }),
  getSalesDetailBatch: (orderIds) => request({ url: '/api/erp/sales/batch', method: 'post', data: orderIds }),
  updateSalesOrder: (data) => request({ url: `/api/erp/sales/update`, method: 'post', data }),
  updateInvoiceStatus: (data) => request({ url: '/api/erp/sales/update-invoice-status', method: 'post', data }),
  receivePayment: (data) => request({ url: '/api/erp/sales/payment', method: 'post', data }),
  // 导出销售订单列表
  exportSalesList: (data) => request({ url: '/api/erp/sales/export', method: 'post', data, responseType: 'blob' }),
  // 导出详细销售订单列表
  exportSalesListDetailed: (data) => request({ url: '/api/erp/sales/export-detailed', method: 'post', data, responseType: 'blob' }),
  // 获取销售订单数据用于图片导出
  getSalesListForExport: (data) => request({ url: '/api/erp/sales/export-data', method: 'post', data }),
  // 获取销售订单明细列表
  getSalesDetailsList: (data) => request({ url: '/api/erp/sales/details/grid', method: 'post', data }),
  // 销售退货相关接口
  createSaleReturn: (data) => request({ url: '/api/erp/sales/return/create', method: 'post', data }),
  getSaleReturnList: (data) => request({ url: '/api/erp/sales/return/grid', method: 'post', data }),
  AuditSaleReturn: (data) => request({ url: '/api/erp/sales/return/audit', method: 'post', data }),
  UnAuditSaleReturn: (data) => request({ url: '/api/erp/sales/return/unaudit', method: 'post', data }),
  DeleteSaleReturn: (id) => request({ url: `/api/erp/sales/return/${id}`, method: 'delete' }),
  // 获取销售退货单详情
  getSaleReturnDetail: (id) => request({ url: `/api/erp/sales/return/${id}`, method: 'get' }),
  // 更新销售退货单
  updateSaleReturn: (data) => request({ url: '/api/erp/sales/return/update', method: 'put', data }),
  // 导出销售退货列表
  exportSaleReturnList: (data) => request({ url: '/api/erp/sales/return/export', method: 'post', data, responseType: 'blob' }),
  setTop: (data) => request({ url: '/api/erp/sales/settop', method: 'post', data }),
};

// 进货退货相关接口
export const purchaseReturnApi = {
  getList: (data) => request({ url: '/api/erp/purchase/return/grid', method: 'post', data }),
  getPurchaseReturnOrderById: (id) => request({ url: `/api/erp/purchase/return/${id}`, method: 'get' }),
  create: (data) => request({ url: '/api/erp/purchase/return/create', method: 'post', data }),
  audit: (id) => request({ url: '/api/erp/purchase/return/audit', method: 'post', data: id }),
  unaudit: (id) => request({ url: '/api/erp/purchase/return/unaudit', method: 'post', data: id }),
  AuditOrder: (data) => request({ url: '/api/erp/purchase/return/audit', method: 'post', data }),
  UnAuditOrder: (data) => request({ url: '/api/erp/purchase/return/unaudit', method: 'post', data }),
  batchDelete: (ids) => request({ url: '/api/erp/purchase/return/batchdelete', method: 'post', data: { ids } }),
  deletePurchaseReturn: (id) => request({ url: '/api/erp/purchase/return/delete', method: 'post', data: id }),
  getPurchaseReturnDetail: (id) => request({ url: `/api/erp/purchase/return/${id}`, method: 'get' }),
  updatePurchaseReturn: (id, data) => request({ url: `/api/erp/purchase/return/${id}`, method: 'put', data }),
  // 导出进货退货列表
  exportPurchaseReturnList: (data) => request({ url: '/api/erp/purchase/return/export', method: 'post', data, responseType: 'blob' }),
}

export const financeApi = {
  initcustomeryszk: (data) => request({ url: '/api/erp/finance/initcustomeryszk', method: 'post', data }),
  initcustomeryfzk: (data) => request({ url: '/api/erp/finance/initcustomeryfzk', method: 'post', data }),


  // 商户管理相关接口
  getBankAccountList: (params) => request.post('/api/erp/bankaccounts/grid', params),
  createBankAccount: (data) => request.post('/api/erp/bankaccounts/create', data),
  updateBankAccount: (id, data) => request.put(`/api/erp/bankaccounts/${id}`, data),
  deleteBankAccount: (id) => request.delete(`/api/erp/bankaccounts/${id}`),
  
  // 银行账户统计相关接口
  getBankAccountStatistics: (params) => request.post('/api/erp/bankaccounts/statistics', params),
  getAllAccountsStatistics: (params) => request.post('/api/erp/bankaccounts/statistics/all', params),
  
  // 导出银行账户列表
  exportBankAccounts: (data) => request.post('/api/erp/bankaccounts/export', data, { responseType: 'blob' }),

  // 发票相关接口
  createInvoice: (data) => request.post('/api/erp/finance/invoices', data),
  updateInvoice: (id, data) => request.put(`/api/erp/invoices/${id}`, data),
  deleteInvoice: (id) => request.delete(`/api/erp/finance/invoices/${id}`),
  getInvoiceList: (params) => request.post('/api/erp/finance/grid', params),
  getInvoiceApplicationList: (params) => request.post('/api/erp/finance/invoice-applications/grid', params),
  getInvoiceDetail: (id) => request.get(`/api/erp/finance/invoices/${id}`),
  getCustomerDetail: (id) => request.get(`/api/erp/customers/${id}`),
  AuditOrder: (data) => request.put(`/api/erp/finance/invoices/${data.id}/approve`, data),
  UnAuditOrder: (data) => request.put(`/api/erp/finance/invoices/${data.id}/reject`, data),
  invoiceApprove: (id, data) => request.put(`/api/erp/finance/invoices/${id}/approve`, data),
  invoiceReject: (id, data) => request.put(`/api/erp/finance/invoices/${id}/reject`, data),
  getInvoiceById: (id) => request.get(`/api/erp/finance/invoices/${id}`),
  getInvoiceOrders: (id) => request.get(`/api/erp/finance/invoices/${id}/orders`),
  compileInvoice: (data) => request.post('/api/erp/finance/invoices/compile', data),
  uploadInvoiceAttachment: (data) => request.post('/api/erp/finance/invoices/upload-attachment', data),

  // 收款单相关接口
  getReceiptVoucherList: (params) => request.post('/api/erp/finance/receipt-vouchers/grid', params),
  createReceiptVoucher: (data) => request.post('/api/erp/finance/receipt-vouchers', data),
  updateReceiptVoucher: (id, data) => request.put(`/api/erp/finance/receipt-vouchers/${id}`, data),
  deleteReceiptVoucher: (id) => request.delete(`/api/erp/finance/receipt-vouchers/${id}`),
  getReceiptVoucherById: (id) => request.get(`/api/erp/finance/receipt-vouchers/${id}`),
  getReceiptVoucherDetail: (id) => request.get(`/api/erp/finance/receipt-vouchers/${id}/detail`),
  auditReceiptVoucher: (id, data) => request.put(`/api/erp/finance/receipt-vouchers/${id}/audit`, data),
  unauditReceiptVoucher: (id) => request.put(`/api/erp/finance/receipt-vouchers/${id}/unaudit`),
  voidReceiptVoucher: (id, data) => request.put(`/api/erp/finance/receipt-vouchers/${id}/void`, data),

  // 付款单相关接口
  getPaymentVoucherList: (params) => request.post('/api/erp/finance/payment-vouchers/grid', params),
  createPaymentVoucher: (data) => request.post('/api/erp/finance/payment-vouchers', data),
  updatePaymentVoucher: (id, data) => request.put(`/api/erp/finance/payment-vouchers/${id}`, data),
  deletePaymentVoucher: (id) => request.delete(`/api/erp/finance/payment-vouchers/${id}`),
  getPaymentVoucherById: (id) => request.get(`/api/erp/finance/payment-vouchers/${id}`),
  getPaymentVoucherDetail: (id) => request.get(`/api/erp/finance/payment-vouchers/${id}/detail`),
  auditPaymentVoucher: (id, data) => request.put(`/api/erp/finance/payment-vouchers/${id}/audit`, data),
  unauditPaymentVoucher: (id) => request.put(`/api/erp/finance/payment-vouchers/${id}/unaudit`),
  voidPaymentVoucher: (id, data) => request.put(`/api/erp/finance/payment-vouchers/${id}/void`, data),

  // 付款单审批相关接口
  submitPaymentVoucherApproval: (id, data) => request.post(`/api/erp/finance/payment-vouchers/${id}/submit-approval`, data),
  approvePaymentVoucher: (id, data) => request.post(`/api/erp/finance/payment-vouchers/${id}/approve`, data),
  rejectPaymentVoucher: (id, data) => request.post(`/api/erp/finance/payment-vouchers/${id}/reject`, data),
  withdrawPaymentVoucherApproval: (id, data) => request.post(`/api/erp/finance/payment-vouchers/${id}/withdraw`, data),
  cancelPaymentVoucherApproval: (id, data) => request.post(`/api/erp/finance/payment-vouchers/${id}/cancel`, data),
  getPaymentVoucherApprovalHistory: (id) => request.get(`/api/erp/finance/payment-vouchers/${id}/approval-history`),
  canApprovePaymentVoucher: (id) => request.get(`/api/erp/finance/payment-vouchers/${id}/can-approve`),

  // 退款单功能已合并到付款单中，使用付款单相关接口并设置voucherType为'退款单'

  // 单据序号相关接口
  getNextVoucherNo: (voucherType) => request.get(`/api/erp/finance/voucher-sequences/next/${voucherType}`),

  // 导出收款单列表
  exportReceiptVoucherList: (params) => {
    return request({
      url: '/api/erp/finance/receipt-vouchers/export',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },

  // 导出收款明细列表
  exportReceiptVoucherDetails: (params) => {
    return request({
      url: '/api/erp/finance/receipt-vouchers/export-details',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },

  // 导出付款单列表
  exportPaymentVoucherList: (params) => {
    return request({
      url: '/api/erp/finance/payment-vouchers/export',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },

  // 导出付款明细列表
  exportPaymentVoucherDetails: (params) => {
    return request({
      url: '/api/erp/finance/payment-vouchers/export-details',
      method: 'post',
      data: params,
      responseType: 'blob'
    })
  },

}
export const suppliersApi = {
  getSuppliers: (data) => request({ url: '/api/erp/suppliers/grid', method: 'post', data }),
  getSupplier: (id) => request({ url: `/api/erp/suppliers/${id}`, method: 'get' }),
  createSupplier: (data) => request({ url: '/api/erp/suppliers/create', method: 'post', data }),
  updateSupplier: (id, data) => request({ url: `/api/erp/suppliers/${id}`, method: 'put', data }),
  deleteSupplier: (id) => request.delete(`/api/erp/suppliers/${id}`),
  exportSuppliers: (params) => request({ url: '/api/erp/suppliers/export', method: 'post', data: params, responseType: 'blob' }),
  
  // 供应商分类相关接口
  getCategories: () => request({ 
    url: '/api/erp/suppliers/supplierscategory', 
    method: 'post',
    timeout: 10000,
    retry: 2
  }),
  getCategoryTree: () => request({ 
    url: '/api/erp/suppliers/category/tree', 
    method: 'get',
    timeout: 10000,
    retry: 2
  }),
  getCategoryList: () => request({ 
    url: '/api/erp/suppliers/category/list', 
    method: 'get',
    timeout: 10000,
    retry: 2
  }),
  createCategory: (data) => {
    if (!data || !data.name) {
      return Promise.reject(new Error('分类名称不能为空'));
    }
    return request({ 
      url: '/api/erp/suppliers/category/create', 
      method: 'post', 
      data,
      timeout: 10000
    });
  },
  updateCategory: (id, data) => {
    if (!id || !data || !data.name) {
      return Promise.reject(new Error('参数不完整'));
    }
    return request({ 
      url: `/api/erp/suppliers/category/${id}`, 
      method: 'put', 
      data,
      timeout: 10000
    });
  },
  deleteCategory: (id) => {
    if (!id) {
      return Promise.reject(new Error('分类ID不能为空'));
    }
    return request({ 
      url: `/api/erp/suppliers/category/${id}`, 
      method: 'delete',
      timeout: 10000
    });
  },
  
  // 品牌相关接口
  getBrands: (params) => request({ url: '/api/brands', method: 'get', params }),
  createBrand: (data) => request({ url: '/api/brands', method: 'post', data }),
  getSupplierBrands: (supplierId) => request({ url: `/api/erp/suppliers/${supplierId}/brands`, method: 'get' }),
  updateSupplierBrands: (supplierId, data) => request({ url: `/api/erp/suppliers/${supplierId}/brands`, method: 'put', data })
}

// 公司财务相关接口
// 公司财务相关接口
export const companyFinanceApi = {
  // 财务分类相关接口
  getCategories: () => request({ url: '/api/erp/company-finance/categories', method: 'get' }),
  createCategory: (data) => request({ url: '/api/erp/company-finance/categories', method: 'post', data }),
  updateCategory: (id, data) => request({ url: `/api/erp/company-finance/categories/${id}`, method: 'put', data }),
  deleteCategory: (id) => request({ url: `/api/erp/company-finance/categories/${id}`, method: 'delete' }),

  // 财务记录相关接口
  getRecords: (data) => request({ url: '/api/erp/company-finance/records/grid', method: 'post', data }),
  createRecord: (data) => request({ url: '/api/erp/company-finance/records', method: 'post', data }),
  updateRecord: (id, data) => request({ url: `/api/erp/company-finance/records/${id}`, method: 'put', data }),
  deleteRecord: (id) => request({ url: `/api/erp/company-finance/records/${id}`, method: 'delete' }),

  // 财务统计相关接口
  getStatistics: (data) => request({ url: '/api/erp/company-finance/statistics', method: 'post', data }),

  // 批量导入财务记录
  batchImportRecords: (data) => request({ url: '/api/erp/company-finance/records/batch', method: 'post', data }),

  // 应收欠款统计报表
  getReceivableList: (data) => request({ url: '/api/erp/finance/receivable-list', method: 'post', data }),

  // 获取应收账款总体统计数据
  getReceivableStatistics: (data) => request({ url: '/api/erp/finance/receivable-statistics', method: 'post', data }),

  // 导出应收账款列表
  exportReceivableList: (data) => request({ url: '/api/erp/finance/receivable-list/export', method: 'post', data, responseType: 'blob' }),

  // 获取客户欠款详情
  getReceivableDetail: (data) => request({ url: `/api/erp/receivable/grid`, method: 'post', data }),

  // 导出应收账款详情
  exportReceivableDetail: (data) => request({ url: '/api/erp/receivable/export-detail', method: 'post', data, responseType: 'blob' }),

  // 应付欠款报表
  getPayableList: (data) => request({ url: '/api/erp/finance/payable-list', method: 'post', data }),

  // 获取应付账款总体统计数据
  getPayableStatistics: (data) => request({ url: '/api/erp/finance/payable-statistics', method: 'post', data }),

  // 导出应付账款列表
  exportPayableList: (data) => request({ url: '/api/erp/finance/payable-list/export', method: 'post', data, responseType: 'blob' }),

  // 应付欠款详情
  getPayableDetail: (data) => request({ url: `/api/erp/payable/grid`, method: 'post', data }),
  // 导出应付账款详情
  exportPayableDetail: (data) => request({ url: '/api/erp/payable/export-detail', method: 'post', data, responseType: 'blob' }),

  // 资金流水相关接口
  getFundFlowList: (data) => request({ url: '/api/erp/finance/fund-flows/grid', method: 'post', data }),
  getAccountFundFlows: (accountId, data) => request({ url: `/api/erp/finance/fund-flows/account/${accountId}`, method: 'post', data }),
  getFundFlowStatistics: (data) => request({ url: '/api/erp/finance/fund-flows/statistics', method: 'post', data }),

  // 获取资金流水详情
  getFundFlowDetail: (id) => request.get(`/api/erp/finance/fund-flows/${id}`),

  // 获取资金流水历史记录
  getFundFlowHistory: (id) => request.get(`/api/erp/finance/fund-flows/${id}/history`),

  // 导出资金流水Excel
  exportFundFlows: (data) => request({ url: '/api/erp/finance/fund-flows/export', method: 'post', data, responseType: 'blob' }),

};

export const writeoffApi = {
  // 核销单相关接口
  getWriteOffVoucherList: (data) => request.post('/api/writeoff-vouchers/grid', data),
  getWriteOffVoucherDetail: (id) => request.get(`/api/writeoff-vouchers/${id}`),
  createWriteOffVoucher: (data) => request.post('/api/writeoff-vouchers/create', data),
  updateWriteOffVoucher: (id, data) => request.put(`/api/writeoff-vouchers/${id}`, data),
  deleteWriteOffVoucher: (id) => request.delete(`/api/writeoff-vouchers/${id}`),
  batchDeleteWriteOffVoucher: (ids) => request.post('/api/writeoff-vouchers/batch-delete', { ids }),
  auditWriteOffVoucher: (data) => request.post('/api/writeoff-vouchers/audit', data),
  unauditWriteOffVoucher: (data) => request.post('/api/writeoff-vouchers/unaudit', data),
  batchAuditWriteOffVoucher: (ids, data) => request.post('/api/writeoff-vouchers/batch-audit', { ids, ...data }),
  generateWriteOffVoucherNo: () => request.get('/api/writeoff-vouchers/generate-voucher-no'),
  GetWriteOffableOrders: (data) => request.post('/api/writeoff-vouchers/writeoffable-orders', data),
  // 导出核销单列表
  exportWriteOffVouchers: (data) => request.post('/api/writeoff-vouchers/export', data, { responseType: 'blob' }),
  // 导出核销单明细
  exportWriteOffVoucherDetails: (data) => request.post('/api/writeoff-vouchers/export-details', data, { responseType: 'blob' }),
}

export const purchaseApi = {
  getPurchaseById: (id) => request({ url: `/api/erp/purchase/${id}`, method: 'get' }),
  getPurchaseList: (data) => request({ url: '/api/erp/purchase/grid', method: 'post', data }),
  createPurchase: (data) => request({ url: '/api/erp/purchase/orders', method: 'post', data }),
  AuditOrder: (data) => request.post(`/api/erp/purchase/orders/audit`, data),
  UnAuditOrder: (data) => request.post(`/api/erp/purchase/orders/unAudit`, data),
  getPurchaseDetail: (id) => request({ url: `/api/erp/purchase/${id}`, method: 'get' }),
  updatePurchase: (id, data) => request({ url: `/api/erp/purchase/${id}`, method: 'put', data }),
  deletePurchase: (id) => request({ url: `/api/erp/purchase/${id}`, method: 'delete' }),
  updatePurchaseStatus: (data) => request({ url: '/api/erp/purchase/UpdatePurchaseStatus', method: 'post', data }),
  updatePaymentStatus: (data) => request({ url: '/api/erp/purchase/update-payment-status', method: 'post', data }),
  makePayment: (data) => request({ url: '/api/erp/purchase/payment', method: 'post', data }),
  // 导出进货订单列表
  exportPurchaseList: (data) => request({ url: '/api/erp/purchase/export', method: 'post', data, responseType: 'blob' }),
  // 导出进货订单详细报表
  exportPurchaseListDetailed: (data) => request({ url: '/api/erp/purchase/export-detailed', method: 'post', data, responseType: 'blob' }),
  // 获取进货订单明细列表
  getPurchaseDetailsList: (data) => request({ url: '/api/erp/purchase/details/grid', method: 'post', data }),

  // 进货单开票相关接口
  createPurchaseInvoice: (data) => request({ url: '/api/erp/purchase/invoice', method: 'post', data }),

  // 进货待销售相关接口
  //getPendingSalesCount: () => request({url: '/api/erp/purchase/pending-sales/count',method: 'get'}),
  getPendingSalesList: (data) => request({ url: '/api/erp/purchase/pending-sales', method: 'post', data }),
  markAsSold: (id) => request({ url: `/api/erp/purchase/pending-sales/${id}/mark-sold`, method: 'get' }),
  markAsSoldByNo: (purchaseNo) => request({ url: `/api/erp/purchase/pending-sales/${purchaseNo}/mark-sold-byno`, method: 'get' }),
  setTop: (data) => request({ url: '/api/erp/purchase/settop', method: 'post', data }),
  getListByIds: (data) => request({ url: '/api/erp/purchase/list-by-ids', method: 'post', data}),
}

// 商品相关接口
export const productApi = {

  // 获取商品详情
  getProductDetail: (id) => request({ url: `/api/erp/products/${id}`, method: 'get' }),
  // 获取商品相关推荐
  getProductRelated: (id) => request({ url: `/api/erp/product/${id}/related`, method: 'get' }),
  //根据查询参数获取商品列表，支持分页。
  //getProductList: (data) => request({url: '/api/goods/grid',method: 'post',data}),
  getProductList: (data) => request({ url: '/api/erp/products/grid', method: 'post', data }),

  GetBrands: () => request({ url: '/api/brands', method: 'get' }),
  createBrand: (data) => request({ url: '/api/brands', method: 'post', data }),
  GetCategorys: () => request({ url: '/api/categories', method: 'get' }),
  createProduct: (data) => request({ url: '/api/erp/products/createproduct', method: 'post', data }),
  updateProduct: (id, data) => request({ url: `/api/erp/products/${id}`, method: 'put', data }),
  deleteProduct: (id) => request({ url: `/api/erp/products/${id}`, method: 'delete' }),
  batchDeleteProducts: (ids) => request({ url: '/api/erp/products/batchdelete', method: 'post', data: ids }),
  getProductStock: (id) => request({ url: `/api/erp/products/${id}/stock`, method: 'get' }),

  // 批量获取商品实时信息（库存、最近售价、最近成本价）
  getProductsRealtimeInfo: (productIds) => request({ url: '/api/erp/products/batch-realtime-info', method: 'post', data: productIds }),

  // 导出商品
  exportToExcel: (params) => request({ url: '/api/erp/products/export', method: 'post', data: params, responseType: 'blob' }),

  // 更新商品发布状态
  updatePublishStatus: (id, isPublished) => request({ url: `/api/erp/products/${id}/publish-status`, method: 'put', data: isPublished, headers: { 'Content-Type': 'application/json' } }),
};

export const adminmerchantsApi = {
  // 商户管理相关接口
  getMerchantList: (params) => request.post('/api/adminmerchants/grid', params),
  createMerchant: (data) => request.post('/api/adminmerchants', data),
  updateMerchant: (id, data) => request.put(`/api/adminmerchants/${id}`, data),
  deleteMerchant: (id) => request.delete(`/api/adminmerchants/${id}`),
  updateMerchantStatus: (data) => request.post('/api/adminmerchants/UpdateMerchantStatus', data),

  // 客户管理相关接口
  getCustomerList: (params) => request.post('/api/adminmerchants/customers', params),
  getDashboardStats: () => request.get('/api/adminmerchants/dashboard-stats'),

  // 佣金列表相关接口
  getCommissionList: (params) => request.post('/api/adminmerchants/commissions', params),
  getCommissionStats: () => request.get('/api/adminmerchants/commission-stats'),

  // 商品管理相关接口
  getProducts: (data) => request({ url: '/api/products/grid', method: 'post', data }),
  AddProduct: (data) => request({ url: '/api/products/addproduct', method: 'post', data }),
  updateProduct: (id, data) => request({ url: `/api/products/${id}`, method: 'put', data }),
  deleteProduct: (id) => request({ url: `/api/products/${id}`, method: 'delete' }),
  getProductDetail: (id) => request({ url: `/api/products/${id}`, method: 'get' }),
  updateProductPublishStatus: (id, isPublished) => request({ url: `/api/products/${id}/${isPublished ? 'publish' : 'unpublish'}`, method: 'put' }),
  // 获取商品列表
  deleteProductRelation: (data) => request({ url: '/api/products/deleterelation', method: 'post', data }),
  addProductRelations: (data) => request({ url: '/api/products/addrelations', method: 'post', data }),
}

// 销售报表相关接口
export const salesReportApi = {
  // 获取销售报表数据
  getSalesReport: (data) => request({ url: '/api/erp/reports/sales/data', method: 'post', data }),
  // 导出销售报表
  exportSalesReport: (data) => request({ url: '/api/erp/reports/sales/export', method: 'post', data, responseType: 'blob' }),
  // 获取当前用户信息
  getCurrentUser: () => request({ url: '/api/erp/reports/sales/current-user', method: 'get' }),
  // 获取制单人列表
  getCreatorList: () => request({ url: '/api/erp/reports/sales/creators', method: 'get' }),
  // 获取业务员列表
  getSalesmanList: () => request({ url: '/api/erp/reports/sales/salesmen', method: 'get' }),
  // 获取商户列表（仅管理员可用）
  getMerchantList: () => request({ url: '/api/erp/reports/sales/merchants', method: 'get' }),
  // 生成月度销售记录
  generateMonthlyRecords: () => request({ url: '/api/erp/reports/sales/generate-monthly-records', method: 'post' }),
  // 获取月度销售数据
  getMonthlySalesData: (params) => request({ url: '/api/erp/reports/sales/monthly-sales', method: 'get', params }),
}
//退货报表相关接口
export const purchaseReportApi = {
  // 获取退货报表数据
  getPurchaseReport: (data) => request({ url: '/api/erp/reports/purchase/data', method: 'post', data }),
  // 导出退货报表
  exportPurchaseReport: (data) => request({ url: '/api/erp/reports/purchase/export', method: 'post', data, responseType: 'blob' }),
  // 获取当前用户信息
  getCurrentUser: () => request({ url: '/api/erp/reports/purchase/current-user', method: 'get' }),
  // 获取业务员列表
  getSalesmanList: () => request({ url: '/api/erp/reports/purchase/salesmen', method: 'get' }),
  // 获取商户列表（仅管理员可用）
  getMerchantList: () => request({ url: '/api/erp/reports/purchase/merchants', method: 'get' }),
  // 获取商品列表
  getProductList: (data) => request({ url: '/api/erp/products/grid', method: 'post', data }),
  // 获取供应商列表
  getSupplierList: () => request({ url: '/api/erp/reports/purchase/suppliers', method: 'get' }),
  // 获取采购订单列表
  getPurchaseOrderList: (data) => request({ url: '/api/erp/reports/purchase/orders', method: 'post', data }),
}

// 数据授权相关接口
export const dataAuthorizationApi = {
  // 获取授权列表
  getAuthorizationList: (data) => request({ url: '/api/user-authorizations/grid', method: 'post', data }),
  // 创建授权
  createAuthorization: (data) => request({ url: '/api/user-authorizations', method: 'post', data }),
  // 更新授权
  updateAuthorization: (id, data) => request({ url: `/api/user-authorizations/${id}`, method: 'put', data }),
  // 删除授权
  deleteAuthorization: (id) => request({ url: `/api/user-authorizations/${id}`, method: 'delete' }),
  // 更新授权状态
  updateAuthorizationStatus: (id, isEnabled) => request({ url: `/api/user-authorizations/${id}/status`, method: 'put', data: { isEnabled } }),
  // 获取用户授权的目标用户ID列表
  getAuthorizedTargetUserIds: (authorizerUserId) => request({ url: `/api/user-authorizations/authorized-users/${authorizerUserId}`, method: 'get' }),
  // 检查用户是否有权限查看目标用户的数据
  checkUserAuthorization: (authorizerUserId, targetUserId) => request({ url: `/api/user-authorizations/check`, method: 'get', params: { authorizerUserId, targetUserId } })
};

// 仪表盘相关接口
export const dashboardApi = {
  // 获取销售报表数据
  getSalesReport: (data) => request({ url: '/api/erp/dashboard/data', method: 'post', data }),
  // 导出销售报表
  exportSalesReport: (data) => request({ url: '/api/erp/dashboard/export', method: 'post', data, responseType: 'blob' }),
  // 获取进货报表数据
  getPurchaseReport: (data) => request({ url: '/api/erp/dashboard/purchase-data', method: 'post', data }),
  // 获取当前用户信息
  getCurrentUser: () => request({ url: '/api/erp/dashboard/current-user', method: 'get' }),
  // 获取业务员列表
  getSalesmanList: () => request({ url: '/api/erp/dashboard/salesmen', method: 'get' }),
  // 获取商户列表（仅管理员可用）
  getMerchantList: () => request({ url: '/api/erp/dashboard/merchants', method: 'get' }),
  // 获取资产统计数据
  getAssetStatistics: (data) => request({ url: '/api/erp/dashboard/asset-statistics', method: 'post', data }),

  // 获取待审批统计数据
  getPendingApprovalStats: () => request({ url: '/api/erp/dashboard/pending-approval-stats', method: 'get' }),

  // 同步月度销售记录
  syncMonthlyRecords: (year) => request({ url: `/api/erp/dashboard/sync-monthly-records?year=${year || ''}`, method: 'post' }),
  // 获取销售趋势（支持自定义时间范围）
  getSalesTrend: (data) => request({ url: '/api/erp/dashboard/sales-trend', method: 'post', data }),
  // 获取月度销售汇总
  getMonthlySalesSummary: (data) => request({ url: '/api/erp/dashboard/monthly-sales-summary', method: 'post', data }),
  // 获取12个月销售趋势
  getSalesTrend12Months: (salesmanIds) => request({ url: '/api/erp/dashboard/sales-trend-12months', method: 'post', data: salesmanIds }),
}

// 员工提成报表相关接口
export const reportsApi = {
  // 获取员工提成报表数据
  getEmployeeCommissionReport: (data) => request({ url: '/api/erp/reports/employee-commission/data', method: 'post', data }),
  // 导出员工提成报表
  exportEmployeeCommissionReport: (data) => request({ url: '/api/erp/reports/employee-commission/export', method: 'post', data, responseType: 'blob' }),
  // 获取员工列表
  getEmployeeList: () => request({ url: '/api/erp/reports/employee-commission/employees', method: 'get' }),
  // 获取员工提成汇总统计
  getEmployeeCommissionSummary: (params) => request({ url: '/api/erp/reports/employee-commission/summary', method: 'get', params }),
  // 获取员工提成月度报表
  getEmployeeCommissionMonthlyReport: (params) => request({ url: '/api/erp/reports/employee-commission/monthly', method: 'get', params }),
  // 获取提成规则列表
  getCommissionRules: () => request({ url: '/api/erp/reports/employee-commission/commission-rules', method: 'get' }),
  // 创建提成规则
  createCommissionRule: (data) => request({ url: '/api/erp/reports/employee-commission/commission-rules', method: 'post', data }),
  // 更新提成规则
  updateCommissionRule: (id, data) => request({ url: `/api/erp/reports/employee-commission/commission-rules/${id}`, method: 'put', data }),
}

// 财务报表API
export const financeReportApi = {
  // 获取公司财务报表
  getCompanyFinanceReport: (params) => request({ url: '/api/erp/reports/finance/company-report', method: 'post', data: params }),

  // 导出公司财务报表
  exportCompanyFinanceReport: (params) => request({ url: '/api/erp/reports/finance/company-report/export', method: 'post', data: params, responseType: 'blob' }),

  // 获取本月应收账款统计
  getMonthlyReceivable: () => request({ url: '/api/erp/reports/finance/monthly-receivable', method: 'get' }),

  // 获取本月应付账款统计
  getMonthlyPayable: () => request({ url: '/api/erp/reports/finance/monthly-payable', method: 'get' }),

  // 获取本月销售统计
  getMonthlySales: () => request({ url: '/api/erp/reports/finance/monthly-sales', method: 'get' }),

  // 获取本月进货统计
  getMonthlyPurchase: () => request({ url: '/api/erp/reports/finance/monthly-purchase', method: 'get' }),

    // 获取公司财务报表明细
  getCompanyFinanceReportDetail: (params) => request({
    url: '/api/erp/reports/finance/company-report/detail',
    method: 'post',
    data: params
  }),

  // 获取其他收入/支出的分类统计
  getCategoryBreakdown: (params) => request({
    url: '/api/erp/reports/finance/company-report/category-breakdown',
    method: 'post',
    data: params
  }),// 获取其他收入/支出的分类统计
  getCategoryBreakdownChild: (params) => request({
    url: '/api/erp/reports/finance/company-report/category-breakdown-child',
    method: 'post',
    data: params
  }),
};

export const incomeExpenseTypeApi = {
  // 获取收入支出类型列表
  getIncomeExpenseTypeList: (params) => request({ url: '/api/erp/income-expense-types/grid', method: 'post', data: params }),
  // 获取所有启用的收支类型（用于下拉选择）
  getActiveIncomeExpenseTypes: () => request({ url: '/api/erp/income-expense-types/active', method: 'get' }),
  // 获取层级结构的收支类型树
  getIncomeExpenseTypeTree: (type) => request({ url: '/api/erp/income-expense-types/tree', method: 'get', params: type ? { type } : {} }),
  // 根据ID获取收支类型详情
  getIncomeExpenseTypeById: (id) => request({ url: `/api/erp/income-expense-types/${id}`, method: 'get' }),
  // 创建收入支出类型
  createIncomeExpenseType: (data) => request({ url: '/api/erp/income-expense-types/create', method: 'post', data }),
  // 更新收入支出类型
  updateIncomeExpenseType: (data) => request({ url: '/api/erp/income-expense-types/update', method: 'post', data }),
  // 删除收入支出类型
  deleteIncomeExpenseType: (id) => request({ url: `/api/erp/income-expense-types/${id}`, method: 'delete' }),
  // 启用/禁用收支类型
  toggleIncomeExpenseTypeStatus: (id) => request({ url: `/api/erp/income-expense-types/${id}/toggle-status`, method: 'post' }),
  // 批量删除收支类型
  batchDeleteIncomeExpenseType: (ids) => request({ url: '/api/erp/income-expense-types/batch-delete', method: 'post', data: { ids } }),
}

export const incomeExpenseRecordApi = {
  // 获取收支记录列表
  getIncomeExpenseRecordList: (params) => request({ url: '/api/erp/income-expense-records/grid', method: 'post', data: params }),
  // 根据ID获取收支记录详情
  getIncomeExpenseRecord: (id) => request({ url: `/api/erp/income-expense-records/${id}`, method: 'get' }),
  // 创建收支记录
  createIncomeExpenseRecord: (data) => request({ url: '/api/erp/income-expense-records/create', method: 'post', data }),
  // 更新收支记录
  updateIncomeExpenseRecord: (data) => request({ url: '/api/erp/income-expense-records/update', method: 'post', data }),
  // 删除收支记录
  deleteIncomeExpenseRecord: (id) => request({ url: `/api/erp/income-expense-records/${id}`, method: 'delete' }),
  // 获取收支统计数据
  getIncomeExpenseStatistics: (params) => request({ url: '/api/erp/income-expense-records/statistics', method: 'post', data: params }),
  // 审核收支记录
  auditIncomeExpenseRecord: (data) => request({ url: '/api/erp/income-expense-records/audit', method: 'post', data }),
  // 反审核收支记录
  unauditIncomeExpenseRecord: (data) => request({ url: '/api/erp/income-expense-records/unaudit', method: 'post', data }),
  // 导出Excel
  exportToExcel: (params) => request({ url: '/api/erp/income-expense-records/export', method: 'post', data: params, responseType: 'blob' }),
}

// 收付款单位相关接口
export const payeePayerApi = {
  // 获取收款单位列表
  getPayeeUnits: (params) => request({ url: '/api/erp/payee-units/grid', method: 'post', data: params }),
  // 获取付款单位列表
  getPayerUnits: (params) => request({ url: '/api/erp/payer-units/grid', method: 'post', data: params }),
  // 创建收款单位
  createPayeeUnit: (data) => request({ url: '/api/erp/payee-units/create', method: 'post', data }),
  // 创建付款单位
  createPayerUnit: (data) => request({ url: '/api/erp/payer-units/create', method: 'post', data }),
  // 更新收款单位
  updatePayeeUnit: (id, data) => request({ url: `/api/erp/payee-units/${id}`, method: 'put', data }),
  // 更新付款单位
  updatePayerUnit: (id, data) => request({ url: `/api/erp/payer-units/${id}`, method: 'put', data }),
  // 删除收款单位
  deletePayeeUnit: (id) => request({ url: `/api/erp/payee-units/${id}`, method: 'delete' }),
  // 删除付款单位
  deletePayerUnit: (id) => request({ url: `/api/erp/payer-units/${id}`, method: 'delete' }),
}

// 审批流程相关接口
export const approvalApi = {
  // 审批流程管理
  getWorkflows: (data) => request({ url: '/api/approval-workflow/grid', method: 'post', data }),
  getWorkflow: (id) => request({ url: `/api/approval-workflow/workflows/${id}`, method: 'get' }),
  getWorkflowByBusinessType: (businessType) => request({ url: `/api/approval-workflow/workflows/by-business-type/${businessType}`, method: 'get' }),
  createWorkflow: (data) => request({ url: '/api/approval-workflow/workflows', method: 'post', data }),
  updateWorkflow: (id, data) => request({ url: `/api/approval-workflow/workflows/${id}`, method: 'put', data }),
  deleteWorkflow: (id) => request({ url: `/api/approval-workflow/workflows/${id}`, method: 'delete' }),
  toggleWorkflowStatus: (id, isActive) => request({ url: `/api/approval-workflow/workflows/${id}/toggle-status`, method: 'patch', data: isActive }),
  
  // 审批实例管理
  submitApproval: (data) => request({ url: '/api/approval-workflow/instances/submit', method: 'post', data }),
  approveInstance: (instanceId, data) => request({ url: `/api/approval-workflow/instances/${instanceId}/approve`, method: 'post', data }),
  rejectInstance: (instanceId, data) => request({ url: `/api/approval-workflow/instances/${instanceId}/reject`, method: 'post', data }),
  withdrawInstance: (instanceId, data) => request({ url: `/api/approval-workflow/instances/${instanceId}/withdraw`, method: 'post', data }),
  cancelInstance: (instanceId, data) => request({ url: `/api/approval-workflow/instances/${instanceId}/cancel`, method: 'post', data }),
  canApprove: (instanceId) => request({ url: `/api/approval-workflow/instances/${instanceId}/can-approve`, method: 'get' }),
  
  // 审批查询
  getPendingApprovals: (params) => request({ url: '/api/approval-workflow/pending-approvals', method: 'get', params }),
  getCompletedApprovals: (params) => request({ url: '/api/approval-workflow/completed-approvals', method: 'get', params }),
  // 我的审批请求
  getMyApprovalRequests: (params) => request({ url: '/api/approval-workflow/my-requests', method: 'get', params }),
  // 我的申请列表
  getMyApplications: (data) => request({ url: '/api/approval-workflow/my-applications', method: 'post', data }),
  getMyApplicationStats: () => request({ url: '/api/approval-workflow/my-application-stats', method: 'get' }),
  getMyApprovalStats: () => request({ url: '/api/approval-workflow/my-approval-stats', method: 'get' }),
  getApprovalHistory: (instanceId) => request({ url: `/api/approval-workflow/instances/${instanceId}/history`, method: 'get' }),
  getApplicationDetail: (instanceId) => request({ url: `/api/approval-workflow/instances/${instanceId}/detail`, method: 'get' }),
  markAsRead: (id) => request({ url: `/api/approval-workflow/instances/${id}/read`, method: 'post' }),
  markAsUnread: (id) => request({ url: `/api/approval-workflow/instances/${id}/unread`, method: 'post' }),
  markAsPrinted: (id) => request({ url: `/api/approval-workflow/instances/${id}/printed`, method: 'post' }),
  getApprovalStatistics: () => request({ url: '/api/approval-workflow/statistics', method: 'get' }),
  getApprovalRecordsHistory: (params) => request({ url: '/api/approval-workflow/records-history', method: 'get', params }),
  
  // 邮件通知相关
  resendEmailNotification: (emailLogId) => request({ url: `/api/approval-workflow/email-notifications/${emailLogId}/resend`, method: 'post' }),
  getEmailLogs: (params) => request({ url: '/api/approval-workflow/email-logs', method: 'get', params }),
  
  // 邮件模板管理
  getEmailTemplates: (params) => request({ url: '/api/email/templates', method: 'get', params }),
  getEmailTemplate: (id) => request({ url: `/api/email/templates/${id}`, method: 'get' }),
  createEmailTemplate: (data) => request({ url: '/api/email/templates', method: 'post', data }),
  updateEmailTemplate: (id, data) => request({ url: `/api/email/templates/${id}`, method: 'put', data }),
  deleteEmailTemplate: (id) => request({ url: `/api/email/templates/${id}`, method: 'delete' }),
  testEmailTemplate: (data) => request({ url: '/api/email/test', method: 'post', data }),
  
  // 邮件链接审批
  approveByEmail: (data) => request({ url: '/api/approval-workflow/email-approve', method: 'post', data }),
  // 查看进货单明细
  getEmailPurchaseList: (token) => request({ url: `/api/approval-workflow/email-purchase-list?token=${token}`, method: 'get' }),

  validateEmailToken: (token) => request({ url: `/api/approval-workflow/email-token/validate?token=${token}`, method: 'get' }),
  getEmailApprovalData: (params) => request({ url: '/api/approval-workflow/email-approval-data', method: 'get', params }),
  processEmailApproval: (data) => request({ url: '/api/approval-workflow/process-email-approval', method: 'post', data }),
  getEmailApprovalDetail: (params) => request({ url: '/api/approval-workflow/email-approval-detail', method: 'get', params }),
  //getApprovalHistory: (instanceId) => request({ url: `/api/approval-workflow/instances/${instanceId}/history`, method: 'get' }),
  
  // 审批人员搜索
  searchUsers: (keyword) => request({ url: `/api/approval-workflow/users?keyword=${keyword}`, method: 'get' }),
  searchRoles: (keyword) => request({ url: `/api/approval-workflow/roles?keyword=${keyword}`, method: 'get' }),
  searchDepartments: (keyword) => request({ url: `/api/approval-workflow/departments?keyword=${keyword}`, method: 'get' }),
  searchPositions: (keyword) => request({ url: `/api/approval-workflow/positions?keyword=${keyword}`, method: 'get' }),
  
  // 审批历史搜索建议
  searchBusinessTypes: (keyword) => request({ url: `/api/approval-workflow/search/business-types?keyword=${keyword}`, method: 'get' }),
  searchApplicants: (keyword) => request({ url: `/api/approval-workflow/search/applicants?keyword=${keyword}`, method: 'get' }),
  searchApprovers: (keyword) => request({ url: `/api/approval-workflow/search/approvers?keyword=${keyword}`, method: 'get' }),
  
  // 获取申请打印数据
  getApplicationPrintData: (instanceId) => request({ url: `/api/approval-workflow/instances/${instanceId}/print-data`, method: 'get' }),
  
  // 撤销申请
  cancelApplication: (instanceId, reason) => request({ 
    url: `/api/approval-workflow/instances/${instanceId}/cancel-application`, 
    method: 'post', 
    data: { Reason: reason } 
  }),
  // 获取分享链接
  getShareLink: (instanceId, authCode) => request({ 
    url: `/api/approval-workflow/instances/${instanceId}/share-link`, 
    method: 'get',
    params: { authCode }
  })
}

// 系统配置相关接口
export const configApi = {
  // 获取系统配置
  getConfig: () => request({ url: '/api/erp/config', method: 'get' }),
  // 保存系统配置
  saveConfig: (data) => request({ url: '/api/erp/config', method: 'post', data }),
  // 重置系统配置
  resetConfig: () => request({ url: '/api/erp/config/reset', method: 'post' })
}

// 客户报表相关接口
export const customerReportApi = {
  // 获取近期未下单客户
  getCustomersWithNoOrders: (data) => request({ url: '/api/erp/reports/customer/no-orders', method: 'post', data }),
  // 获取近期未回款客户
  getCustomersWithNoPayments: (data) => request({ url: '/api/erp/reports/customer/no-payments', method: 'post', data }),
  // 获取客户下单排行
  getCustomerOrderRanking: (data) => request({ url: '/api/erp/reports/customer/order-ranking', method: 'post', data }),
  
  // 获取客户统计概览
  getCustomerOverview: (data) => request({ url: '/api/erp/reports/customer/overview', method: 'post', data }),
  // 获取客户价值分析
  getCustomerValueAnalysis: (data) => request({ url: '/api/erp/reports/customer/value-analysis', method: 'post', data }),
  // 获取客户行为分析
  getCustomerBehaviorAnalysis: (params) => request({ url: '/api/erp/reports/customer/behavior-analysis', method: 'get', params }),
  // 获取客户风险分析
  getCustomerRiskAnalysis: (params) => request({ url: '/api/erp/reports/customer/risk-analysis', method: 'get', params })
}

// 渠道商等级配置接口
export const channelLevelConfigApi = {
  getList: (data) => request({ url: '/api/channel-level-configs/grid', method: 'post', data }),
  getDetail: (id) => request({ url: `/api/channel-level-configs/${id}`, method: 'get' }),
  create: (data) => request({ url: '/api/channel-level-configs', method: 'post', data }),
  update: (id, data) => request({ url: `/api/channel-level-configs/${id}`, method: 'put', data }),
  delete: (id) => request({ url: `/api/channel-level-configs/${id}`, method: 'delete' }),
}

// 渠道商管理接口
export const channelMerchantApi = {
  getList: (data) => request({ url: '/api/channel-merchants/grid', method: 'post', data }),
  updateLevel: (id, data) => request({ url: `/api/channel-merchants/${id}/update-level`, method: 'put', data }),
}

